import { PlatformConfig } from '../interfaces/config.interfaces';

/**
 * Default platform configuration
 * This serves as the base configuration that can be overridden by environment-specific configs
 */
export const defaultConfig: PlatformConfig = {
  meta: {
    title: 'Platform Application',
    description: 'A modern platform application',
    keywords: ['platform', 'application'],
    author: 'Platform Team',
    ogType: 'website',
    twitterCard: 'summary',
    robots: 'index, follow',
    viewport: 'width=device-width, initial-scale=1',
    charset: 'UTF-8',
    lang: 'en',
  },
  branding: {
    appName: 'Platform',
    appShortName: 'Platform',
    primaryColor: '#3b82f6',
    secondaryColor: '#8b5cf6',
    accentColor: '#10b981',
    companyName: 'Platform Company',
    supportEmail: 'support@platform.com',
    copyright: `© ${new Date().getFullYear()} Platform Company. All rights reserved.`,
  },
  theme: {
    defaultTheme: 'light',
    themes: {},
    enableThemeSwitcher: true,
    persistTheme: true,
  },
  i18n: {
    defaultLocale: 'en',
    supportedLocales: ['en', 'fa'],
    fallbackLocale: 'en',
    enableTranslationCache: true,
    dateFormat: 'YYYY-MM-DD',
    timeFormat: 'HH:mm:ss',
    currency: 'USD',
    numberFormat: 'en-US',
    showLanguageSwitcher: true,
    rtlLanguages: ['fa'],
  },
  layout: {
    topbar: {
      enabled: true,
      height: '5rem',
      sticky: true,
      showLogo: true,
      showMenu: true,
      showUserMenu: true,
    },
    sidebar: {
      enabled: true,
      width: '300px',
      collapsible: true,
      defaultCollapsed: false,
      position: 'start',
    },
    footer: {
      enabled: true,
      height: '48px',
    },
    breadcrumbs: {
      enabled: true,
      showHome: true,
    },
    container: {
      maxWidth: null ,
      padding: '0',
    },
    typography: {
      fontFamily:
        '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      baseFontSize: '15px',
      lineHeight: 1,
      fontWeight: {
        light: 300,
        normal: 400,
        medium: 500,
        semibold: 600,
        bold: 700,
      },
    },
    spacing: {
      baseUnit: '0.2rem',
      scale: {
        xs: '0.25rem',
        sm: '0.5rem',
        md: '1rem',
        lg: '1.5rem',
        xl: '2rem',
        '2xl': '3rem',
        '3xl': '4rem',
        '4xl': '6rem',
      },
    },
  },
  modules: {},
  features: {},
  auth: {
    enabled: false,
    provider: 'jwt',
    tokenStorage: 'localStorage',
    refreshTokenEnabled: false,
    autoRefresh: false,
    loginRoute: '/login',
    logoutRoute: '/logout',
    redirectAfterLogin: '/',
    redirectAfterLogout: '/login',
  },
  integrations: {},
  api: {
    baseUrl: '/api',
    timeout: 30000,
    retryAttempts: 3,
    retryDelay: 1000,
    headers: {
      'Content-Type': 'application/json',
    },
    interceptors: {
      request: true,
      response: true,
      error: true,
    },
  },
  environment: 'development',
  version: '1.0.0',
  debug: false,
};
